export { default } from "/Users/julian/work/personal/wwsu-2022/app/routes/$festivalSlug/info-staende/index.tsx";